{
  "ENROLLMENT_CREATED": {
    "title": "¡Nuevo curso disponible!",
    "message": "Te inscribiste en {{productTitle}}"
  },
  "COURSE_COMPLETED": {
    "title": "¡Curso completado!",
    "message": "¡Felicidades! Completaste {{productTitle}}"
  },
  "LESSON_COMPLETED": {
    "title": "¡Clase completada!",
    "message": "Completaste \"{{lessonTitle}}\""
  },
  "POINTS_EARNED": {
    "title": "¡Puntos conseguidos!",
    "message": "Ganaste {{points}} XP"
  },
  "COMMUNITY_POINTS_EARNED": {
    "title": "¡+{{points}} XP en la comunidad!",
    "message": "Ganaste {{points}} XP en la comunidad"
  },
  "LEVEL_UP": {
    "title": "¡Nivel alcanzado!",
    "message": "Subiste a {{levelName}}"
  },
  "COMMENT_REPLY": {
    "title": "Nueva respuesta a tu comentario",
    "message": "{{replierName}} ha respondido: \"{{snippet}}\""
  },
  "COMMENT_REACTION": {
    "title": "Tu comentario ha recibido un me gusta",
    "message": "A {{reactorName}} le ha gustado tu comentario"
  },
  "PAYMENT_APPROVED": {
    "title": "Pago confirmado",
    "message": "Tu pago de {{offerName}} ha sido aprobado"
  },
  "DAILY_CHECKLIST_TASK": {
    "title": "Checklist diario",
    "message": "¡Completaste la tarea: {{actionLabel}}! +{{points}} XP"
  },
  "DAILY_CHECKLIST_BONUS": {
    "title": "¡Trifecta diaria completada!",
    "message": "¡Felicidades! Completaste todas las tareas diarias y ganaste +{{bonusPoints}} XP de bonificación."
  },
  "STREAK_MILESTONE": {
    "title": "¡{{streakDays}} días seguidos!",
    "message": "¡{{streakDays}} días seguidos estudiando!",
    "message_7": "¡Felicidades! ¡7 días seguidos estudiando! 🔥",
    "message_14": "¡Impresionante! ¡2 semanas seguidas estudiando! 🚀",
    "message_30": "¡INCREÍBLE! ¡30 días seguidos! ¡Eres imparable! ⭐",
    "message_60": "¡Leyenda! ¡60 días de disciplina pura! 🏆",
    "message_90": "¡ÉPICO! ¡90 días seguidos! ¡Eres una inspiración! 💎",
    "message_180": "¡LEGENDARIO! ¡6 meses de dedicación absoluta! 👑",
    "message_365": "¡SUPREMO! ¡1 AÑO COMPLETO! ¡Hiciste historia! 🌟"
  },
  "STREAK_BROKEN": {
    "title": "Tu racha se ha interrumpido",
    "message": "Tu racha de {{brokenStreak}} días se ha interrumpido. No te rindas, ¡empieza una nueva hoy!"
  },
  "CHALLENGE_COMPLETED": {
    "title": "¡Reto completado!",
    "message": "¡Felicidades! Completaste el reto \"{{challengeTitle}}\"."
  },
  "WEEKLY_BADGE_EARNED": {
    "title": "¡Insignia semanal conseguida!",
    "message": "¡Felicidades! Quedaste en el puesto {{rank}} de la semana y ganaste la insignia \"{{badgeName}}\"."
  },
  "REWARD_REDEEMED": {
    "title": "¡Recompensa canjeada!",
    "message": "¡Canjeaste \"{{rewardTitle}}\" por {{costXp}} XP!"
  },
  "REWARD_STATUS_UPDATED": {
    "title": "Estado de la recompensa actualizado",
    "message": "Se ha actualizado el estado del canje de \"{{rewardTitle}}\".",
    "message_pending": "Tu canje de \"{{rewardTitle}}\" se está procesando.",
    "message_processing": "Tu canje de \"{{rewardTitle}}\" está en proceso.",
    "message_delivered": "¡Tu canje de \"{{rewardTitle}}\" se ha entregado correctamente!",
    "message_cancelled": "Tu canje de \"{{rewardTitle}}\" se ha cancelado y se te han devuelto los XP."
  },
  "ADMIN_REDEMPTION_ALERT": {
    "title": "Nueva solicitud de canje",
    "message": "Un usuario ha canjeado \"{{rewardTitle}}\". Se requiere una acción."
  },
  "checklistActions": {
    "post": "publicación",
    "comment": "comentario",
    "like": "me gusta"
  }
}
